



























import {
  computed,
  defineComponent,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { useApp } from '~/compositions/app'
import { useDeps } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useI18n } from '~/compositions/i18n'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    hideLogin: {
      type: Boolean,
      default: false
    },
    hideRegister: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { modelValue, hideLogin, hideRegister } = toRefs(props)
    const isVisible = ref(modelValue.value)
    const { t } = useI18n()

    const { isCar } = useApp()
    const [legacyUrlService] = useDeps(LegacyUrlService)

    watch(modelValue, newModelValue => (isVisible.value = newModelValue))
    watch(isVisible, newIsVisible => emit('update:modelValue', newIsVisible))

    const website = computed(() => (isCar.value ? 'Car.gr' : 'Plot.gr'))

    const registerUrl = computed(() =>
      legacyUrlService.getRegisterUrl({ gotonext: window.location.href })
    )

    const text = computed(() => {
      if (hideLogin.value) {
        return t('register_to_access', { website: website.value })
      } else if (hideRegister.value) {
        return t('login_to_access', { website: website.value })
      }

      return t('login_to_your_account', { website: website.value })
    })

    const loginUrl = computed(
      () =>
        `${legacyUrlService.getUserLoginUrl()}?gotonext=${window.location.href}`
    )

    return { isVisible, website, registerUrl, loginUrl, text }
  }
})
